import React from "react";
import ReactDOM from "react-dom";
import MUIDataTable from "mui-datatables";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Cities from "./cities";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

const getMuiTheme = () => createMuiTheme({
  overrides: {
    MUIDataTableBodyCell: {
      root: {
        paddingLeft: '5px',
        paddingRight: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
      }
    },
    MUIDataTableHeadCell: {
      root: {
        paddingLeft: '5px',
        paddingRight: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
      }
    }
  }
})

class App extends React.Component {
  state = {
    theme: getMuiTheme()
  }

  render() {
    const { data, onClick } = this.props

    const columns = [
      {
        name: "event_id",
        label: "ID",
        options: {
          filter: false
        }
      },
      {
        name: 'event_type',
        label: "Type",
        options: {
          filter: true
        }
      },
      {
        name: 'event_class',
        label: "Class",
        options: {
          filter: true
        }
      },
      {
        name: 'route_name',
        label: "Route",
        options: {
          searchable: false,
          filter: false,
          display: false
        }
      },
      {
        name: 'distance',
        label: "Distance",
        options: {
          searchable: false,
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {            
            return value.toFixed(1)
          }
        }
      },
      {
        name: 'comment',
        label: "Comment",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: 'report',
        label: "Report",
        options: {
          filter: true,
          filterList: ['Y'],
          customFilterListRender: v => {
            return v === 'Y' ? 'Reported' : 'Not Reported'
          },
          searchable: false,
          display: false
        }
      },
      {
        name: 'longitude',
        label: "Longitude",
        options: {
          searchable: false,
          filter: false,
          display: false
        }
      },
      {
        name: 'latitude',
        label: "Latitude",
        options: {
          searchable: false,
          filter: false,
          display: false
        }
      },
    ];

    const options = {
      elevation: 0,
      filter: true,
      filterType: "checkbox",
      onRowClick: onClick,
      print: false,
      // responsive: "scroll",
      responsive: "stacked",
      rowsPerPage: 5,
      rowsPerPageOptions: [5, 10, 25, 100],
      selectableRows: 'none',
    };

    return (
      <MuiThemeProvider theme={this.state.theme}>
        <MUIDataTable        
          data={data}
          columns={columns}
          options={options}
        />
      </MuiThemeProvider>
    );
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/TableSearch.js